import { authService } from 'spec';
import permissionFunctions from './permission-functions';

// Avoid using arrow functions here because of problems in functional context. (https://stackoverflow.com/questions/12995153/apply-not-working-as-expected)
// Please declare auth object concise as possible.

export async function GetAuthObject() {
  const claims = await authService.getClaims();
  const { app_type: userAppType, role, name } = claims;
  const appType = userAppType.toLowerCase();

  return {
    /* ********* below permissions will append to tailing of the desired permissions *********** */

    // At Least 1 claim be true --> AL1
    // Register --> R
    // Edit --> E
    // Normal Edit --> NE
    // Protected Edit --> PE
    // Register and Edit --> RE
    // Delete --> D
    // Print Information --> PI

    /* ***************************************************************************************** */
    IsAfghanVersion: permissionFunctions.IsAfghanVersion(appType, role),
    AfghanBankLinks: permissionFunctions.AfghanBankLinks(role, appType),
    IsAdmin: permissionFunctions.IsAdmin(role, appType),
    AfghanExcelPI: permissionFunctions.AfghanExcelPI(role, appType),
    ArchiveAccountsR: permissionFunctions.ArchiveAccountsR(role, appType),
    ArchivedAccountsA: permissionFunctions.ArchivedAccountsA(role, appType),
    BankAccountsList: permissionFunctions.BankAccountsList(role, appType),
    BankTransactionRE: permissionFunctions.BankTransactionRE(role, appType),
    BankbookA: permissionFunctions.BankbookA(role, appType),
    BankBookD: permissionFunctions.BankBookD(role, appType),
    BankBookRE: permissionFunctions.BankBookRE(role, appType),
    BranchAccountA: permissionFunctions.BranchAccountA(role, appType),
    BranchAccountD: permissionFunctions.BranchAccountD(role, appType),
    BranchAccountRE: permissionFunctions.BranchAccountRE(role, appType),
    BranchD: permissionFunctions.BranchD(role, appType),
    BranchFullAccess: permissionFunctions.BranchFullAccess(role, appType),
    BranchR: permissionFunctions.BranchR(role, appType),
    BranchesListA: permissionFunctions.BranchesListA(role, appType),
    BranchesA: permissionFunctions.BranchesA(role, appType),
    PaymentPlaceA: permissionFunctions.PaymentPlaceA(role, appType),
    CashTransactionRE: permissionFunctions.CashTransactionRE(role, appType),
    CheckoutsD: permissionFunctions.CheckoutsD(role, appType),
    CommissionReportsA: permissionFunctions.CommissionReportsA(role, appType),
    CreateDeputyEmployee: permissionFunctions.CreateDeputyEmployee(
      role,
      appType
    ),
    CurrencyManagementA: permissionFunctions.CurrencyManagementA(role, appType),
    CurrencyManagementList: permissionFunctions.CurrencyManagementList(
      role,
      appType
    ),
    customerR: permissionFunctions.customerR(role),
    CustomerD: permissionFunctions.CustomerD(role, appType),
    CustomerE: permissionFunctions.CustomerE(role, appType),
    CompanyD: permissionFunctions.CompanyD(role, appType),
    CompanyE: permissionFunctions.CompanyE(role, appType),
    CustomerRwithLimitation: permissionFunctions.CustomerRwithLimitation(
      role,
      appType
    ),
    CustomersListA: permissionFunctions.CustomersListA(role, appType),
    ReceiversListA: permissionFunctions.ReceiversListA(role, appType),
    DayOperation: permissionFunctions.DayOperation(role, appType),
    DebtorCreditorA: permissionFunctions.DebtorCreditorA(role, appType),
    DebtorCreditorRemainingTime:
      permissionFunctions.DebtorCreditorRemainingTime(role, appType),
    DraftDocumentsListA: permissionFunctions.DraftDocumentsListA(role, appType),
    DraftExecutionR: permissionFunctions.DraftExecutionR(role, appType),
    DraftRE: permissionFunctions.DraftRE(role, appType),
    EmployeeE: permissionFunctions.EmployeeE(role, appType),
    EmployeeR: permissionFunctions.EmployeeR(role, appType),
    ExcelPI: permissionFunctions.ExcelPI(role, appType),
    FinancialOperationsA: permissionFunctions.FinancialOperationsA(
      role,
      appType
    ),
    HideAccountA: permissionFunctions.HideAccountA(role, appType),
    HidenAccountA: permissionFunctions.HidenAccountA(role, appType),
    HidenAccountR: permissionFunctions.HidenAccountR(role, appType),
    IncreaseCustomerCredit: permissionFunctions.IncreaseCustomerCredit(
      role,
      appType
    ),
    DecreaseCustomerCredit: permissionFunctions.DecreaseCustomerCredit(
      role,
      appType
    ),
    InitialCreditR: permissionFunctions.InitialCreditR(role, appType),
    InterbankTransactionRE: permissionFunctions.InterbankTransactionRE(
      role,
      appType
    ),
    ManageOrganizationGroupsA: permissionFunctions.ManageOrganizationGroupsA(
      role,
      appType
    ),
    ManagerEmployeeR: permissionFunctions.ManagerEmployeeR(role, appType),
    OrganizationChartA: permissionFunctions.OrganizationChartA(role, appType),
    OrganizationChartE: permissionFunctions.OrganizationChartE(role, appType),
    PaymentOrderA: permissionFunctions.PaymentOrderA(role, appType),
    PendingDraftsList: permissionFunctions.PendingDraftsList(role, appType),
    PrivateTransactionR: permissionFunctions.PrivateTransactionR(role, appType),
    ProfitAndLossStatement: permissionFunctions.ProfitAndLossStatement(
      role,
      appType
    ),
    RegisterAccountGroups: permissionFunctions.RegisterAccountGroups(
      role,
      appType
    ),
    RePrintReceipt: permissionFunctions.RePrintReceipt(role, appType),
    SuggestedGroupsInSettings: permissionFunctions.SuggestedGroupsInSettings(
      role,
      appType
    ),
    SystemAccountsD: permissionFunctions.SystemAccountsD(role, appType),
    SystemAccountsList: permissionFunctions.SystemAccountsList(role, appType),
    SystemAccountsRE: permissionFunctions.SystemAccountsRE(role, appType),
    SystemSettingsA: permissionFunctions.SystemSettingsA(role, appType),
    TradeCurrencyA: permissionFunctions.TradeCurrencyA(role, appType),
    TradeCurrencyRE: permissionFunctions.TradeCurrencyRE(role, appType),
    TransactionGroupAndMoneyPurpose:
      permissionFunctions.TransactionGroupAndMoneyPurpose(role, appType),
    TransferBetweenAccountsRE: permissionFunctions.TransferBetweenAccountsRE(
      role,
      appType
    ),
    UnknownBankTransactionsA: permissionFunctions.UnknownBankTransactionsA(
      role,
      appType
    ),
    WhatsappA: permissionFunctions.WhatsappA(claims),
    WhatsappConnectionR: permissionFunctions.WhatsappConnectionR(claims),
    ChequesListA: permissionFunctions.ChequesListA(role, appType),
    ExchangersCreditAccountA: permissionFunctions.ExchangersCreditAccountA(
      role,
      appType
    ),
    SupportCreditCustomer: permissionFunctions.SupportCreditCustomer(role, appType),
    IsBasicBranch: permissionFunctions.IsBasicBranch(appType),
    ShowExecuteDraftReceipt: permissionFunctions.ShowExecuteDraftReceipt(role),
    userName: name,
    role,
    appType,
    SystemAccountsA: permissionFunctions.SystemAccountsA(role, appType),
    settlementA: permissionFunctions.settlementA(appType),
    notesA: permissionFunctions.notesA(appType),
    SystemSettingItemA: permissionFunctions.SystemSettingItemA(appType),
    AdvancedSearch: permissionFunctions.AdvancedSearch(appType),
    dayOperationApproval: permissionFunctions.dayOperationApproval(appType, role),
    OrganizationListA: permissionFunctions.OrganizationListA(appType, role),
    PaymentDetailsA: permissionFunctions.PaymentDetailsA(appType, role)
  };
}

export default GetAuthObject;
